"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RPCResponseParser = void 0;
var number_1 = require("../number");
var RPCResponseParser = /** @class */ (function () {
    function RPCResponseParser() {
    }
    RPCResponseParser.prototype.parseGetBlockResponse = function (res) {
        return {
            timestamp: res.timestamp,
            block_hash: res.block_hash,
            block_number: res.block_number,
            new_root: res.new_root,
            parent_hash: res.parent_hash,
            status: res.status,
            transactions: res.transactions,
        };
    };
    RPCResponseParser.prototype.parseGetTransactionResponse = function (res) {
        return {
            calldata: res.calldata || [],
            contract_address: res.contract_address,
            max_fee: res.max_fee,
            nonce: res.nonce,
            signature: res.signature || [],
            transaction_hash: res.transaction_hash,
            version: res.version,
        };
    };
    RPCResponseParser.prototype.parseFeeEstimateResponse = function (res) {
        return {
            overall_fee: (0, number_1.toBN)(res.overall_fee),
            gas_consumed: (0, number_1.toBN)(res.gas_consumed),
            gas_price: (0, number_1.toBN)(res.gas_price),
        };
    };
    RPCResponseParser.prototype.parseCallContractResponse = function (res) {
        return {
            result: res,
        };
    };
    return RPCResponseParser;
}());
exports.RPCResponseParser = RPCResponseParser;
